import { useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Nav from './components/Nav';
import Home from './pages/Home';
import Work from './pages/Work';
import About from './pages/About';
import Thinking from './pages/Thinking';
import PasswordGate from './components/PasswordGate';
import './App.css';

function App() {
  const [unlocked, setUnlocked] = useState(
    sessionStorage.getItem('unlocked') === 'true'
  );

  if (!unlocked) {
    return <PasswordGate onUnlock={() => setUnlocked(true)} />;
  }

  return (
    <Router>
      <div className="app">
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/work" element={<Work />} />
          <Route path="/about" element={<About />} />
          <Route path="/thinking" element={<Thinking />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
